import search from '@/mixins/search'
import pagination from '@/mixins/pagination'
import reactroute from '@/mixins/reactroute'
import socialconnection from '@/mixins/social_connection'
import filtersmix from '@/mixins/filters_mix'
import morefilters from '@/mixins/morefilters'
import reactivewidth from '@/mixins/reactive_width'
import cancel_requests from '@/mixins/cancel_requests'
import campaign from '@/mixins/campaign'
import startnewcampaign from '@/mixins/start_new_campaign'
import whitelabelapps from '@/mixins/whitelabel_apps'

export const Search = search
export const Pagination = pagination
export const ReactRoute = reactroute
export const SocialConnection = socialconnection
export const FiltersMix = filtersmix
export const ReactiveWidth = reactivewidth
export const Campaign = campaign
export const StartNewCampaign = startnewcampaign
export const WhitelabelApps = whitelabelapps
export const MoreFilters = morefilters

// Global mixins
export const CancelRequests = cancel_requests
